
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCookieBite } from "@fortawesome/free-solid-svg-icons";

library.add( faCookieBite );

@Options( { components : { FontAwesomeIcon } } )
export default class Cookies extends Vue
{
  store = useStore( key );
  show  = false;

  mounted()
  {
    // Hide if user agent is the one used by SSR
    if( navigator.userAgent !== "Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)" )
    {
      this.show = localStorage.getItem( "cookies" ) === null;
    }
  }

  accept( val:string )
  {
    localStorage.setItem( "cookies", val );
    this.show = false;
  }
}
